import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@/lib/utils";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "aero:flex aero:items-center aero:gap-2 aero:text-sm aero:leading-none aero:font-medium aero:select-none aero:group-data-[disabled=true]:pointer-events-none aero:group-data-[disabled=true]:opacity-50 aero:peer-disabled:cursor-not-allowed aero:peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
}

export { Label };
